import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IConfigurationServiceListResponse } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setServiceList } from "@/app_redux/reducers/slices/auth/configuration_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useVeticServiceSearchListAPI = () => {
  const configuration = useConfiguration();

  const { captureError } = useAPIUtils();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  //
  const execute = useCallback(
    async (query: string) => {
      dispatch(
        setLoading({
          key: "isServiceListLoadingInProgess",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        await axios
          .get(`${CONFIGURATION_APIS?.SEARCH_MODULE_API?.baseURL}`, {
            params: {
              page: "service",
              search_keyword: query,
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationServiceListResponse>) => {
            if (res.data.data?.length > 0) {
              dispatch(setServiceList({ data: res.data.data }));
              dispatch(
                setLoading({
                  key: "isServiceListLoadingInProgess",
                  status: false,
                }),
              );
            } else {
              dispatch(setServiceList({ data: [] }));
              dispatch(
                setLoading({
                  key: "isServiceListLoadingInProgess",
                  status: false,
                }),
              );
            }
          })
          .catch((e: AxiosError) => {
            dispatch(setServiceList({ data: [] }));
            captureError(e);
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        dispatch(setServiceList({ data: [] }));
        dispatch(
          setLoading({
            key: "isServiceListLoadingInProgess",
            status: false,
          }),
        );
        if (axios.isAxiosError(error)) {
          dispatch(setServiceList({ data: [] }));
          const axiosError = error as AxiosError;
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return { execute };
};
